export default function (count, label, pluralForm) {
    if (count === 1)
        return `1 ${label}`;
    return `${count} ${pluralForm || `${label}s`}`;
}
export function isArrayOfStrings(value) {
    if (!value)
        return false;
    return (Array.isArray(value) && value.every((item) => typeof item === 'string'));
}
